import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";

import "./assets/styles/custom.css";
import Layout from "./components/layout";

import Login from "./pages/Login";
import Estates from "./pages/Estates";
import DocumentForm from "./pages/DocumentForm";
import ProtectedRoute from "./components/shared/ProtectedRoute";
import Upload from "./pages/Upload";

dayjs.extend(localizedFormat);

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<Layout />}>
            <Route index element={<Estates />} />
            <Route path="/documents" element={<Estates />} />
            <Route path="/new-document/:estateId" element={<DocumentForm />} />
            <Route path="/upload" element={<Upload />} />
            <Route path="/users" element={<Estates />} />
            <Route path="/support" element={<Estates />} />
          </Route>
        </Route>
        <Route path="/login" element={<Login />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
